export const basicTreeSubTitle = [
    {
        text: 'Use the dynamic tree view with checkboxes.'
    }
];

export const simpleTreeviewData = {
    name: 'root',
    children: [
        {
            name: 'Applications',
            children: [
                {
                    name: 'Ecommerce',
                    children: [
                        { name: 'Product' },
                        { name: 'Cart' },
                        { name: 'Invoice' },
                    ],
                },
                {
                    name: 'Users',
                    children: [
                        { name: 'Users-profile' },
                        { name: 'Users-edit' },
                        { name: 'Users-cards' },
                    ],
                },
                {
                    name: 'Chat',
                    children: [
                        { name: 'Chat-app' },
                        { name: 'Video-chat' },
                    ],
                },
            ],
        },
        {
            name: 'Components',
            children: [
                {
                    name: 'UI-Kits',
                    children: [
                        { name: 'Typography' },
                        { name: 'Avatars' },
                        { name: 'Grid' },
                    ],
                },
                {
                    name: 'Bonus-UI',
                    children: [
                        { name: 'Toasts' },
                        { name: 'Rating' },
                        { name: 'Pagination' },
                    ],
                },
                {
                    name: 'Charts',
                    children: [
                        { name: 'Apex-chart' },
                        { name: 'Google-chart' },
                        { name: 'Echarts' },
                    ],
                },
            ],
        },
        {
            name: 'Miscellaneous',
            children: [
                {
                    name: 'Gallery',
                    children: [
                        { name: 'Gallery-grid' },
                        { name: 'Gallery-grid-desc' },
                        { name: 'Masonry-gallery' },
                    ],
                },
                {
                    name: 'Blog',
                    children: [
                        { name: 'Blog-details' },
                        { name: 'Blog-single' },
                        { name: 'Add-post' },
                    ],
                },
                {
                    name: 'Editors',
                    children: [
                        { name: 'Summer-note' },
                        { name: 'CK-editor' },
                        { name: 'MDE-editor' },
                    ],
                },
            ],
        },
    ],
};